(function ($) {
  $(document).ready(function () {
    $('.rotator--carousel').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 10000,
      dots: true,
      customPaging: function (slick, index) {
        var targetImage = slick.$slides.eq(index).find('.rotator__item').attr('data-title');
        return '<span>' + targetImage + '</span>';
      },
    });
  });
})(window.jQuery);
